import React, { Component, Fragment } from "react";
import { Modal, Button, Form, Message, Header } from "semantic-ui-react";
import { translate } from "react-i18next";

import gql from "graphql-tag";
import client from "./../store/apolloClient";

import { escapeQuotes, validMail } from "../store/functionUtils";
import Captcha from "./Captcha";

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      mail: "",
      confirm_mail: "",
      name: "",
      user: "",
      region: "",
      mailuser: "",
      message: "",
      captcha: false,
      loading: false,
      error: { hidden: true, text: "" },
      returnMessage: { hidden: true, text: "" },
      userMailCheck: { user: null, mail: null },
      regionOptions: [
        { value: "ag", text: "Agrigento" },
        { value: "al", text: "Alessandria" },
        { value: "an", text: "Ancona" },
        { value: "ao", text: "Aosta" },
        { value: "ar", text: "Arezzo" },
        { value: "ap", text: "Ascoli Piceno" },
        { value: "at", text: "Asti" },
        { value: "av", text: "Avellino" },
        { value: "ba", text: "Bari" },
        { value: "bt", text: "Barletta-Andria-Trani" },
        { value: "bl", text: "Belluno" },
        { value: "bn", text: "Benevento" },
        { value: "bg", text: "Bergamo" },
        { value: "bi", text: "Biella" },
        { value: "bo", text: "Bologna" },
        { value: "bz", text: "Bolzano" },
        { value: "bs", text: "Brescia" },
        { value: "br", text: "Brindisi" },
        { value: "ca", text: "Cagliari" },
        { value: "cl", text: "Caltanissetta" },
        { value: "cb", text: "Campobasso" },
        { value: "ci", text: "Carbonia-iglesias" },
        { value: "ce", text: "Caserta" },
        { value: "ct", text: "Catania" },
        { value: "cz", text: "Catanzaro" },
        { value: "ch", text: "Chieti" },
        { value: "co", text: "Como" },
        { value: "cs", text: "Cosenza" },
        { value: "cr", text: "Cremona" },
        { value: "kr", text: "Crotone" },
        { value: "cn", text: "Cuneo" },
        { value: "en", text: "Enna" },
        { value: "fm", text: "Fermo" },
        { value: "fe", text: "Ferrara" },
        { value: "fi", text: "Firenze" },
        { value: "fg", text: "Foggia" },
        { value: "fc", text: "Forlì-Cesena" },
        { value: "fr", text: "Frosinone" },
        { value: "ge", text: "Genova" },
        { value: "go", text: "Gorizia" },
        { value: "gr", text: "Grosseto" },
        { value: "im", text: "Imperia" },
        { value: "is", text: "Isernia" },
        { value: "sp", text: "La spezia" },
        { value: "aq", text: "L'aquila" },
        { value: "lt", text: "Latina" },
        { value: "le", text: "Lecce" },
        { value: "lc", text: "Lecco" },
        { value: "li", text: "Livorno" },
        { value: "lo", text: "Lodi" },
        { value: "lu", text: "Lucca" },
        { value: "mc", text: "Macerata" },
        { value: "mn", text: "Mantova" },
        { value: "ms", text: "Massa-Carrara" },
        { value: "mt", text: "Matera" },
        { value: "vs", text: "Medio Campidano" },
        { value: "me", text: "Messina" },
        { value: "mi", text: "Milano" },
        { value: "mo", text: "Modena" },
        { value: "mb", text: "Monza e della Brianza" },
        { value: "na", text: "Napoli" },
        { value: "no", text: "Novara" },
        { value: "nu", text: "Nuoro" },
        { value: "og", text: "Ogliastra" },
        { value: "ot", text: "Olbia-Tempio" },
        { value: "or", text: "Oristano" },
        { value: "pd", text: "Padova" },
        { value: "pa", text: "Palermo" },
        { value: "pr", text: "Parma" },
        { value: "pv", text: "Pavia" },
        { value: "pg", text: "Perugia" },
        { value: "pu", text: "Pesaro e Urbino" },
        { value: "pe", text: "Pescara" },
        { value: "pc", text: "Piacenza" },
        { value: "pi", text: "Pisa" },
        { value: "pt", text: "Pistoia" },
        { value: "pn", text: "Pordenone" },
        { value: "pz", text: "Potenza" },
        { value: "po", text: "Prato" },
        { value: "rg", text: "Ragusa" },
        { value: "ra", text: "Ravenna" },
        { value: "rc", text: "Reggio di Calabria" },
        { value: "re", text: "Reggio nell'Emilia" },
        { value: "ri", text: "Rieti" },
        { value: "rn", text: "Rimini" },
        { value: "rm", text: "Roma" },
        { value: "ro", text: "Rovigo" },
        { value: "sa", text: "Salerno" },
        { value: "ss", text: "Sassari" },
        { value: "sv", text: "Savona" },
        { value: "si", text: "Siena" },
        { value: "sr", text: "Siracusa" },
        { value: "so", text: "Sondrio" },
        { value: "ta", text: "Taranto" },
        { value: "te", text: "Teramo" },
        { value: "tr", text: "Terni" },
        { value: "to", text: "Torino" },
        { value: "tp", text: "Trapani" },
        { value: "tn", text: "Trento" },
        { value: "tv", text: "Treviso" },
        { value: "ts", text: "Trieste" },
        { value: "ud", text: "Udine" },
        { value: "va", text: "Varese" },
        { value: "ve", text: "Venezia" },
        { value: "vb", text: "Verbano-Cusio-Ossola" },
        { value: "vc", text: "Vercelli" },
        { value: "vr", text: "Verona" },
        { value: "vv", text: "Vibo valentia" },
        { value: "vi", text: "Vicenza" },
        { value: "vt", text: "Viterbo" },
      ],
    };
  }

  // Handle open/close of the modal
  openCloseModal() {
    if (this.state.open === true) {
      this.setState({
        open: !this.state.open,
        mail: "",
        confirm_mail: "",
        name: "",
        message: "",
        mailuser: "",
        user: "",
        region: "",
        loading: false,
        error: { hidden: true, text: "" },
        returnMessage: { hidden: true, text: "" },
      });
    } else {
      this.setState({ open: !this.state.open });
    }
  }

  // Handle change of the region dropdown
  handleRegion(e, data) {
    this.setState({ region: data.value });
  }

  // Handle onChange of the form
  handleInputForm(type, e) {
    this.setState({ [type]: e.target.value });
  }

  // Check the data before send the mail to the server
  checkData() {
    if (this.props.type === "reset_password") {
      if (this.state.mailuser === "") {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_MAILUSER") },
        });
      } else if (this.state.captcha === false) {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_CAPTCHA") },
        });
      } else {
        const paramName =
          this.state.mailuser.indexOf("@") > 0 ? "email" : "user";
        const formData = {
          [paramName]: this.state.mailuser,
          templated: true,
          template: "simcaa-templ-password",
          variables: `{"password": "${Math.random().toString(36).slice(-8)}"}`,
        };

        this.sendMail(formData);
      }
    } else if (this.props.type === "request_account") {
      if (this.state.name === "") {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_NAME") },
        });
      } else if (this.state.mail === "" || !validMail(this.state.mail)) {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_MAIL") },
        });
        // } else if (this.state.message === "") {
        //   this.setState({
        //     error: { hidden: false, text: this.props.t("ERR_CONTACT_MESSAGE") },
        //   });
      } else if (
        this.state.mail !== this.state.confirm_mail &&
        this.state.mail !== ""
      ) {
        this.setState({
          error: {
            hidden: false,
            text: this.props.t("ERR_CONTACT_CONFIRM_MAIL"),
          },
        });
      } else if (this.state.user === "") {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_USER") },
        });
      } else if (this.state.region === "") {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_REGION") },
        });
      } else if (this.state.captcha === false) {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_CAPTCHA") },
        });
      } else {
        this.requestAccountMailSend();
      }
    } else {
      if (this.state.name === "") {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_NAME") },
        });
      } else if (this.state.mail === "" || !validMail(this.state.mail)) {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_MAIL") },
        });
      } else if (
        this.state.mail !== this.state.confirm_mail &&
        this.state.mail !== ""
      ) {
        this.setState({
          error: {
            hidden: false,
            text: this.props.t("ERR_CONTACT_CONFIRM_MAIL"),
          },
        });
      } else if (this.state.message === "") {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_MESSAGE") },
        });
      } else if (this.state.captcha === false) {
        this.setState({
          error: { hidden: false, text: this.props.t("ERR_CONTACT_CAPTCHA") },
        });
      } else {
        const formData = {
          email: this.state.mail,
          templated: true,
          template: "simcaa-templ-support",
          variables: `{"message": "${escapeQuotes(
            this.state.message
          )}", "name": "${escapeQuotes(this.state.name)}"}`,
        };

        this.sendMail(formData);
      }
    }
  }

  // Check the data and send mail for the account request
  requestAccountMailSend() {
    // if (Object.values(this.state.userMailCheck).every(item => item === false)) {
    let typerequest;
    if (this.props.account === "privato") {
      typerequest = 1;
    } else if (this.props.account === "scuole") {
      typerequest = 2;
    } else {
      typerequest = 3;
    }

    const name = escapeQuotes(this.state.name);
    const formData = {
      email: this.state.mail,
      user: this.state.user,
      templated: true,
      template: "simcaa-templ-account",
      checkDuplicates: true,
      typeAccount: typerequest,
      variables: `{
          "message": "${escapeQuotes(this.state.message)} (${name})",
          "name": "${name}",
          "mail": "${this.state.mail}",
          "region": "${this.state.region}",
          "user": "${escapeQuotes(this.state.user)}"
        }`,
    };

    this.sendMail(formData);
    // }
  }

  // Send mail to the server
  sendMail(body) {
    this.setLoading(true);
    body.variables = body.variables.replace(/\n|\r/g, " ");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(body),
      redirect: "follow",
    };

    this.setState({ error: { hidden: true, text: "" } }, () => {
      fetch(window.env.SESMail, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.code === 200) {
            this.setState(
              {
                returnMessage: {
                  hidden: false,
                  text: this.props.t("CTCT_MSG_EMAILOK"),
                },
              },
              () => {
                setTimeout(() => {
                  this.openCloseModal();
                }, 5000);
              }
            );
            // }
          }
          if (data.code === 500) {
            this.setState({
              error: {
                hidden: false,
                // text: this.props.t("CTCT_MSG_EMAILERROR")
                text: data.error,
              },
              loading: false,
            });
          }
        });
    });
  }

  // Pass the captcha
  validationCaptchaPassed() {
    this.setState({ captcha: true });
  }

  // Set the loading button
  setLoading(value = null) {
    if (value) {
      this.setState({ loading: value });
    } else {
      this.setState({ loading: !this.state.loading });
    }
  }

  // MAIN RENDER
  render() {
    const { t } = this.props;

    let triggerModal, formBody;
    if (this.props.type === "reset_password") {
      triggerModal = (
        <Header
          size="small"
          onClick={this.openCloseModal.bind(this)}
          className="icon-pointer"
          disabled={window.env.demoMode}
        >
          Password dimenticata?
        </Header>
      );
      formBody = (
        <Form.Input
          required
          fluid
          label={t("CTCT_LBL_MAILUSER")}
          placeholder={t("CTCT_LBL_MAILUSER")}
          value={this.state.mailuser}
          onChange={this.handleInputForm.bind(this, "mailuser")}
        />
      );
    } else if (this.props.url || this.props.type === "contact") {
      if (this.props.url) {
        triggerModal = (
          <p className="similar-link" onClick={this.openCloseModal.bind(this)}>
            {this.props.url}
          </p>
        );
      } else {
        triggerModal = (
          <Button
            color={this.props.color}
            style={this.props.style}
            disabled={window.env.demoMode}
            onClick={this.openCloseModal.bind(this)}
          >
            {t("CTCT_BTN_CONTACT")}
          </Button>
        );
      }
      formBody = (
        <Fragment>
          <Form.Group widths="equal">
            <Form.Input
              required
              fluid
              label={t("CTCT_LBL_CONTACTNAME")}
              placeholder={t("CTCT_LBL_CONTACTNAME")}
              value={this.state.name}
              onChange={this.handleInputForm.bind(this, "name")}
            />
            <Form.Input
              required
              fluid
              label={t("CTCT_LBL_CONTACTEMAIL")}
              placeholder={t("CTCT_LBL_CONTACTEMAIL")}
              value={this.state.mail}
              onChange={this.handleInputForm.bind(this, "mail")}
              type="email"
            />
            <Form.Input
              required
              fluid
              label={t("CTCT_LBL_CONTACTCONFIRMEMAIL")}
              placeholder={t("CTCT_LBL_CONTACTCONFIRMEMAIL")}
              value={this.state.confirm_mail}
              onChange={this.handleInputForm.bind(this, "confirm_mail")}
              type="email"
            />
          </Form.Group>
          <Form.TextArea
            required
            label={t("CTCT_LBL_CONTACTMESSAGE")}
            placeholder={t("CTCT_LBL_CONTACTMESSAGE") + "..."}
            value={this.state.message}
            onChange={this.handleInputForm.bind(this, "message")}
          />
        </Fragment>
      );
    } else if (this.props.type === "request_account") {
      triggerModal = (
        <Button
          color={this.props.color}
          style={this.props.style}
          disabled={window.env.demoMode}
          onClick={this.openCloseModal.bind(this)}
        >
          {t("CTCT_BTN_REQUESTACCOUNT")}
        </Button>
      );
      formBody = (
        <Fragment>
          <Form.Group widths="equal">
            <Form.Input
              required
              fluid
              label={t("CTCT_LBL_CONTACTNAME")}
              placeholder={t("CTCT_LBL_CONTACTNAME")}
              value={this.state.name}
              onChange={this.handleInputForm.bind(this, "name")}
            />
            <Form.Select
              required
              fluid
              search
              label={t("CTCT_LBL_CONTACTREGION")}
              placeholder={t("CTCT_LBL_CONTACTREGION")}
              value={this.state.region}
              onChange={this.handleRegion.bind(this)}
              options={this.state.regionOptions}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
              required
              fluid
              label={t("CTCT_LBL_CONTACTUSER")}
              placeholder={t("CTCT_LBL_CONTACTUSER")}
              value={this.state.user}
              onChange={this.handleInputForm.bind(this, "user")}
            />
            <Form.Input
              required
              fluid
              label={t("CTCT_LBL_CONTACTEMAIL")}
              placeholder={t("CTCT_LBL_CONTACTEMAIL")}
              value={this.state.mail}
              onChange={this.handleInputForm.bind(this, "mail")}
              type="email"
            />
            <Form.Input
              required
              fluid
              label={t("CTCT_LBL_CONTACTCONFIRMEMAIL")}
              placeholder={t("CTCT_LBL_CONTACTCONFIRMEMAIL")}
              value={this.state.confirm_mail}
              onChange={this.handleInputForm.bind(this, "confirm_mail")}
              type="email"
            />
          </Form.Group>
          <Form.TextArea
            required={this.props.type === "request_account" ? false : true}
            label={t("CTCT_LBL_CONTACTMESSAGE")}
            placeholder={t("CTCT_LBL_CONTACTMESSAGE") + "..."}
            value={this.state.message}
            onChange={this.handleInputForm.bind(this, "message")}
          />
        </Fragment>
      );
    }

    return (
      <Modal trigger={triggerModal} open={this.state.open}>
        <Modal.Header>{t("CTCT_BTN_CONTACT")}</Modal.Header>
        <Modal.Content>
          <Form>{formBody}</Form>
          <div style={{ textAlign: "center" }}>
            <Captcha
              validationPassedCallback={this.validationCaptchaPassed.bind(this)}
            />
          </div>
          <Message error hidden={this.state.error.hidden}>
            <Message.Header>ERROR!!!</Message.Header>
            {this.state.error.text}
          </Message>
          <Message positive hidden={this.state.returnMessage.hidden}>
            <Message.Header>SUCCESS!!!</Message.Header>
            {this.state.returnMessage.text}
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button
            primary
            onClick={this.checkData.bind(this)}
            loading={this.state.loading}
            disabled={this.state.loading}
          >
            {t("CTCT_BTN_SEND")}
          </Button>
          <Button
            negative
            onClick={this.openCloseModal.bind(this)}
            loading={this.state.loading}
            disabled={this.state.loading}
          >
            {t("MAIN_BTN_CLOSE")}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default translate("translations")(ContactForm);



// WEBPACK FOOTER //
// ./src/components/ContactForm.js